/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const PointOfSalesService = {
  async getPOSDefaultData() {
    const requestScreenData = {
      url: "api/POSDefaultData",
    };
    return await ApiService.oDataGet(requestScreenData);
  },
  async getSalesResForCustomer(CustomerCode) {
    const requestScreenData = {
      url: `api/SalesRepresentative/${CustomerCode}/Default`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getPaymentMethod(invoiceCode) {
    const requestScreenData = {
      url: `api/POSHeader`,
      select: ["PayMethod"],
      filter: `InvoiceCode eq ${invoiceCode}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getPosTransactionDetails(filter, params) {
    const requestScreenData = {
      url: `api/POSProductDetailRefund`,
      filter,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async savePOS(payload) {
    var url = `api/Save_PointOfSale`;

    return await ApiService.post(url, payload);
  },

  async savePOSRefund(payload) {
    var url = `api/Save_POSRefundOrder`;

    return await ApiService.post(url, payload);
  },

  async getPriceDiscountPermission(payload) {
    var url = `CheckPOSPermission`;

    return await ApiService.post(url, payload);
  },

  async validatePOSBarcode(params) {
    const requestScreenData = {
      url: `api/POSProduct`,
      expand: "SalesUMs(select=UnitOfMeasureCode)",
      filter: params.filter,
      key: ["ItemCode", "BranchCode"],
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { PointOfSalesService };
